import { getRecoil, setRecoil } from 'recoil-nexus';

import { clinicalNote as clinicalNoteState } from 'components/state';
import {
  intelligenceChatIdState,
  specialtyState
} from 'components/practice/charts/ClinicalNote/MyScribeAI/state';
import { ambientListeningIntelligenceChatId } from 'components/practice/charts/ClinicalNote/MyScribeAI/Templates/AmbientListening/state';

const updateSpecialty = (data) => {
  const { specialty, intelligence_chat_id, vertical, destId } = data;

  const isCurrentNote = Number(destId) === Number(getRecoil(clinicalNoteState)?.id);
  if (intelligence_chat_id) {
    if (vertical === 'auto_map' && isCurrentNote)
      setRecoil(intelligenceChatIdState, intelligence_chat_id);
    if (vertical === 'ambient_listening' && isCurrentNote)
      setRecoil(ambientListeningIntelligenceChatId, intelligence_chat_id);
  }

  if (specialty) setRecoil(specialtyState, specialty);
};

export default updateSpecialty;
